import Error500 from 'modules/admin/components/Error/Error500';

export default function FallbackUI() {
  return <Error500 />;
}
